import React from 'react';
import PropTypes from 'prop-types';
import Remarkable from 'remarkable';
import RemarkableIframify from '../../../../../../../common/remarkable/iframify';
import RemarkableShortenUrl from '../../../../../../../common/remarkable/shortenurl';
import RemarkableFullScreenImg from '../../../../../../../common/remarkable/fullscreenimg';

const BotTextControl = ({ text }) => {
    const formatMessage = message => {
        if (!message) {
            return message;
        }
        if (typeof message === 'string' || message instanceof String) {
            const md = new Remarkable('full', {
                html: false,
                xhtmlOut: false,
                breaks: true,
                langPrefix: 'md-',
                linkify: true,
                typographer: true,
                quotes: '„”\'\'',
                linkTarget: '_blank'
            });
            md.use(RemarkableShortenUrl);
            md.use(RemarkableIframify); // detect youtube links
            md.use(RemarkableFullScreenImg); // mark images for full screen
            return md.render(message);
        } else {
            return message;
        }
    };

    return <div dangerouslySetInnerHTML={{ __html: formatMessage(text) }} />;
};

BotTextControl.defaultProps = {
    text: ''
};

BotTextControl.propTypes = {
    text: PropTypes.string
};

export default BotTextControl;
